// components/shared/Input.jsx
export function Input({
  label,
  name,
  type = "text",
  value,
  onChange,
  onBlur,
  error,
  required = false,
  placeholder = "",
  disabled = false,
  primaryColor = "#ea580c",
  className = "",
}) {
  const id = `input-${name}`;
  const describedBy = error ? `${id}-error` : undefined;

  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-semibold mb-2" style={{ color: primaryColor }}>
          {label} {required && <span className="text-red-400">*</span>}
        </label>
      )}

      <input
        id={id}
        type={type}
        name={name}
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        onBlur={() => onBlur && onBlur(name)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        aria-invalid={!!error}
        aria-describedby={describedBy}
        className={`w-full px-4 py-2.5 bg-slate-800/40 border text-white placeholder-slate-500 rounded-xl
          focus:ring-2 focus:border-transparent transition
          disabled:opacity-50 disabled:cursor-not-allowed
          ${error ? "border-red-500" : "border-slate-700"}`}
        style={{ "--tw-ring-color": primaryColor }}
      />

      {error && (
        <p id={describedBy} className="text-red-400 text-xs mt-1.5">
          {error}
        </p>
      )}
    </div>
  );
}
